import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { addBanner } from 'slice/bannerSlice';

const AddBanner = () => {
    const [formData, setFormData] = useState({
        name: '',
        selling_price: '',
        shipping_charge: '1000',
        original_price: '',
        rating: '0',
        stock_quantity: '',
        description: '',
        processor: '',
        ram: '',
        storage: '',
        battery_life: '',
        weight: '',
        screen_size: '',
        gpu: '',
        product_id: '',
        stock: '',
        is_active: '1',
        image: null,
    });

    const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.banner);
    const nevigate = useNavigate()

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));

    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }
        try {
            dispatch(addBanner(formDataToSend))
            toast('Banner added successfully!')
            nevigate('/banner')
            setFormData({
                name: '',
                selling_price: '',
                shipping_charge: '1000',
                original_price: '',
                rating: '0',
                stock_quantity: '',
                description: '',
                processor: '',
                ram: '',
                storage: '',
                battery_life: '',
                weight: '',
                screen_size: '',
                gpu: '',
                product_id: '',
                stock: '',
                is_active: '1',
                image: null,
            })
        } catch (error) {
            console.error('There was a problem adding the product:', error.message);
        }
    };

    return (
        <>
            <div className='container-fluid mt-5'>
            <div className='mainheadig mx-4'>
                <h4 className='text-white font-weight-bold '>Add Banner</h4>
            </div>
                <form onSubmit={handleSubmit}>
                    <div className='row mx-4'>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='productName' className='admin-label'>Banner Title</label>
                            <input type='text' id='productName' name='name' value={formData.name} className='form-control' onChange={handleChange} required />
                        </div>
                        <div className='col-sm-6 mt-4'>
                            <label htmlFor='bannerSellingPrice' className='admin-label'>Selling Price</label>
                            <input id='bannerSellingPrice' type='number' name='selling_price' value={formData.selling_price} className='form-control' onChange={handleChange} required />
                        </div>
                        <div className='col-sm-6 mt-4'>
                            <label htmlFor='bannerShipping' className='admin-label'>Shipping Charge</label>
                            <input id='bannerShipping' type='number' name='shipping_charge' value={formData.shipping_charge} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-6 mt-4'>
                            <label htmlFor='bannerOriginalPrice' className='admin-label'>Original Price</label>
                            <input id='bannerOriginalPrice' type='number' name='original_price' value={formData.original_price} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-6 mt-4'>
                            <label htmlFor='bannerRating' className='admin-label'>Rating</label>
                            <input id='bannerRating' type='number' step='0.1' name='rating' value={formData.rating} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-6 mt-4'>
                            <label htmlFor='bannerStockQty' className='admin-label'>Stock Quantity</label>
                            <input id='bannerStockQty' type='number' name='stock_quantity' value={formData.stock_quantity} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerDescription' className='admin-label'>Description</label>
                            <textarea id='bannerDescription' name='description' value={formData.description} className='form-control' rows='3' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerProcessor' className='admin-label'>Processor</label>
                            <input id='bannerProcessor' type='text' name='processor' value={formData.processor} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerRam' className='admin-label'>RAM</label>
                            <input id='bannerRam' type='text' name='ram' value={formData.ram} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerStorage' className='admin-label'>Storage</label>
                            <input id='bannerStorage' type='text' name='storage' value={formData.storage} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerBattery' className='admin-label'>Battery Life</label>
                            <input id='bannerBattery' type='text' name='battery_life' value={formData.battery_life} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerWeight' className='admin-label'>Weight</label>
                            <input id='bannerWeight' type='text' name='weight' value={formData.weight} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerScreen' className='admin-label'>Screen Size</label>
                            <input id='bannerScreen' type='text' name='screen_size' value={formData.screen_size} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerGpu' className='admin-label'>GPU</label>
                            <input id='bannerGpu' type='text' name='gpu' value={formData.gpu} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerProduct' className='admin-label'>Product ID</label>
                            <input id='bannerProduct' type='number' name='product_id' value={formData.product_id} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerStock' className='admin-label'>Stock</label>
                            <input id='bannerStock' type='number' name='stock' value={formData.stock} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='bannerStatus' className='admin-label'>Status</label>
                            <select id='bannerStatus' name='is_active' value={formData.is_active} className='form-control' onChange={handleChange}>
                                <option value='1'>Active</option>
                                <option value='0'>Inactive</option>
                            </select>
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='productName' className='admin-label'>Banner Image</label>
                            <input type='file' id='productName' name='image' className='form-control btn-block filebg' onChange={handleChange} required />
                        </div>
                    </div>
                    <div className='mt-4 text-right mx-4 '>
                        <button className='btn btn-lg addbtn' disabled={loading}>Add Banner</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default AddBanner
